import styled from '@emotion/styled'
import {theme} from '../../features/Dashboard/theme'
import {PTTileBg} from '../../../../assets'

export const StatsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  position: relative;
`

export const SliderBg = styled.div`
  position: absolute;
  border-radius: ${theme.radius.lg};
  background: ${props =>
    `linear-gradient(210deg, ${props.bg} 0%, ${props.bg}dd 100%)`};
  transition: left 0.45s cubic-bezier(0.4, 0, 0.2, 1),
    top 0.45s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.45s cubic-bezier(0.4, 0, 0.2, 1),
    height 0.45s cubic-bezier(0.4, 0, 0.2, 1), background 0.2s ease;
  pointer-events: none;
  z-index: 0;

  &::after {
    content: '';
    position: absolute;
    top: 8px;
    right: -20px;
    width: 80px;
    height: 56px;
    background-image: url('${PTTileBg}');
    background-size: 100% 100%;
    pointer-events: none;
  }
`

export const StatCard = styled.div`
  background: transparent;
  border-radius: ${theme.radius.lg};
  padding: 16px 18px;
  flex: 1;
  width: ${props => (props.selected ? '230px' : 'auto')};
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 92px;
  cursor: pointer;
  position: relative;
  isolation: isolate;
  opacity: ${props => (props.selected ? 1 : 0.85)};
  transition: opacity 0.15s ease, width 0.5s ease, box-shadow 0.15s ease;
  box-shadow: 0 0 15px 1px #cccccc52;

  &:hover {
    opacity: 1;
    box-shadow: 0 2px 12px rgba(73, 70, 153, 0.2);
  }

  @media (max-width: 768px) {
    flex: 1 1 calc(50% - 6px);
    min-width: 0;
  }

  @media (max-width: 480px) {
    flex: 1 1 100%;
  }
`

export const StatIconWrap = styled.div`
  width: 44px;
  height: 44px;
  border-radius: ${theme.radius.md};
  background: ${props => props.bg};
  box-shadow: 0 0 5px 1px #ebe9e944;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${theme.colors.surface};
  position: relative;
  z-index: 1;
`

export const StatBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;
  z-index: 1;
`

export const StatCount = styled.div`
  font-size: 26px;
  font-weight: 800;
  color: ${props =>
    props.selected ? theme.colors.surface : theme.colors.text};
  font-family: ${theme.font.family};
  line-height: 1;
  transition: color 0.45s cubic-bezier(0.4, 0, 0.2, 1);
`

export const StatLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${props =>
    props.selected ? 'rgba(255,255,255,0.75)' : theme.colors.text};
  font-family: ${theme.font.family};
  transition: color 0.45s cubic-bezier(0.4, 0, 0.2, 1);
`
